"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M10 3h4v12h-4z"
}, "1")], 'PriorityHighTwoTone');